import React, { Component } from "react";
import Slider from "react-slick";
import "./carouselNosValeurs.css"
export default class CarouselResponsive extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      responsive: [
        {
          breakpoint: 1045,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
            //initialSlide: 2
          }
        }
      ]
    };
    return (
      <div className="backCarouselRespo">
        <h1 className="valueTitle" style={{textAlign: "center",color: "white"}}>Nos Valeurs</h1>
        <Slider {...settings} style={{paddingBottom : "20px"}}>
          <div>
            <div style={{ width: "70%", height: "215px", background: "white", margin: "0 auto", marginTop: "2%", padding: "3%" }}>
              <div style={{paddingTop: "10px"}}>
                <center><h1 className="StyleTitle">Client</h1></center>
              </div>
              <div style={{ width: "69%", margin: "0 auto" }}>
                <p className="StyleP">Chaque projet Chifco obéit à une philosophie simple : vous redonner le contrôle</p>
              </div>
            </div>
          </div>
          <div>


            <div style={{ width: "70%", height: "215px", background: "#f3f3f3", margin: "0 auto", marginTop: "2%", padding: "3%" }}>
              <div style={{paddingTop: "10px"}}>
                <center><h1 className="StyleTitle">ENTREPRENARIAT</h1></center>
              </div>
              <div style={{ width: "69%", margin: "0 auto" }}>
                <p className="StyleP">Nous avons une culture startup. Nous prenons des risques afin d’innover.</p>
              </div>
            </div>
          </div>
          <div>

            <div style={{ width: "70%", height: "215px", background: "white", margin: "0 auto", marginTop: "2%", padding: "3%" }}>
              <div style={{paddingTop: "10px"}}>
                <center><h1 className="StyleTitle">INNOVATION</h1></center>
              </div>
              <div style={{ width: "69%", margin: "0 auto" }}>
                <p className="StyleP">« Comment puis-je innover aujourd’hui ? » est la pensée quotidienne d’un membre de l’équipe Chifco. </p>
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: "70%", height: "215px", background: "#ffd904", margin: "0 auto", marginTop: "2%", padding: "3%" }}>
              <div style={{paddingTop: "10px"}}>
                <center><h1 className="StyleTitle">TECHNOLOGIE</h1></center>
              </div>
              <div style={{ width: "69%", margin: "0 auto" }}>
                <p className="StyleP">Outre la maîtrise de la technologie d’aujourd’hui, nous ambitionnons également d’inventer celle de demain. </p>
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: "70%", height: "215px", background: "white", margin: "0 auto", marginTop: "2%", padding: "3%" }}>
              <div style={{paddingTop: "10px"}}>
                <center><h1 className="StyleTitle">EQUIPE</h1></center>
              </div>
              <div style={{ width: "69%", margin: "0 auto" }}>
                <p className="StyleP">Nous sommes une famille et le travail d’équipe est la raison principale de notre succès.</p>
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: "70%", height: "215px", background: "white", margin: "0 auto", marginTop: "2%", padding: "3%" }}>
              <div style={{paddingTop: "10px"}}>
                <center><h1 className="StyleTitle">EXCELLENCE</h1></center>
              </div>
              <div style={{ width: "69%", margin: "0 auto" }}>
                <p className="StyleP">Nous aspirons à offrir le meilleur service possible tout en offrant une forte valeur ajoutée. </p>
              </div>
            </div>
          </div>
        </Slider>
        {/* <div className="backdotsCarousel"></div> */}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/home/responsive/carouselNosValeurs.js